<template>
    <div class="form-group">
        <label v-if="label" class="form-label" :for="id">{{ label }}</label>
        <div class="input-group">
            <div class="custom-file">
                <input :id="id" type="file" :value="modelValue" v-bind="{ ...$attrs, class: null }"
                    @input="$emit('update:modelValue', $event.target.value)" class="custom-file-input">
                <label class="custom-file-label" for="exampleInputFile">Pilih file</label>
            </div>
        </div>
        <span v-if="error" style="color:#dc3545; font-size:80%">{{ error }}</span>
    </div>
</template>
  
<script>
import { v4 as uuid } from 'uuid'
import bsCustomFileInput from 'admin-lte/plugins/bs-custom-file-input/bs-custom-file-input.min.js'
export default {
    inheritAttrs: false,
    props: {
        id: {
            type: String,
            default() {
                return `input-file-${uuid()}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        error: String,
        label: String,
        modelValue: String,
    },
    emits: ['update:modelValue'],
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
        setSelectionRange(start, end) {
            this.$refs.input.setSelectionRange(start, end)
        },
    },
    mounted() {
        $(function () {
            bsCustomFileInput.init();
        });
    }
}
</script>